module.exports = __webpack_public_path__ + "selfdestruct.mp3?1648eb757e4ed525d861eabed86382c7";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/sounds/selfdestruct.mp3
// module id = 476
// module chunks = 0